import { render } from "./PlusInCircle.vue?vue&type=template&id=5a2376c6"
const script = {}

import exportComponent from "../../../../../../../projects/loyalzilla_admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/icons/PlusInCircle.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5a2376c6"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5a2376c6', __exports__)) {
    api.reload('5a2376c6', __exports__)
  }
  
  module.hot.accept("./PlusInCircle.vue?vue&type=template&id=5a2376c6", () => {
    api.rerender('5a2376c6', render)
  })

}


export default __exports__